<!-- prettier-ignore -->

<div class="modal-offer-container">
    <div class="modal-offer-container__img-container">
        <img draggable="false" [src]="offer()?.image?.[translate.currentLang]" (error)="tools.onImgOfferError($event)" >
    </div>
    <div class="modal-offer-container__text-container">
        @if(offer()?.description?.[translate.currentLang]){
            <div class="modal-offer-container__text-container__desc">
                <p>{{offer()?.description?.[translate.currentLang]}} </p>
            </div>
        }

        @if(offer()?.start && offer()?.end){
            <div class="modal-offer-container__text-container__date-offer">
                <span>{{'Oferta válida' | translate }}: </span>
                <span>
                    {{'Del' | translate}} {{offer().start | date: 'dd/MM/yy'}} 
                    {{'al' | translate}} {{offer().end | date: 'dd/MM/yy'}}
                </span>
            </div>
        }

        @if(offer()?.code?.[translate.currentLang]){
            <div class="modal-offer-container__text-container__code-offer">
                <span>{{'Código promocional' | translate}}: </span>
                <span>{{offer().code[translate.currentLang]}}</span>
            </div>
        }

        @if(offer()?.link?.[translate.currentLang]){
            <div class="modal-offer-container__text-container__button-offer">
                <button (click)="goToURL(offer().link[translate.currentLang])">{{'Ir a oferta' | translate}}</button>
            </div>
        }
    </div>
</div>

<div (click)="dismissModal()" class="modal-offer-close-button">
    <span>X</span>
</div>
